import { Component } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { Router, Event, NavigationEnd, NavigationError, ActivationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'clientApp';
  public activePath = '';

  constructor(private router: Router,
    private translateService: TranslateService,
    private readonly location: LocationStrategy  ) {

    this.translateService.addLangs(['nl', 'en', 'pl']);
    this.translateService.setDefaultLang('nl');

    this.router.events.subscribe((val: Event) => {

      if (val instanceof NavigationError) {
        const navError = val as NavigationError;
        console.error('cannot route to ' + val.url);
        if (navError.url.startsWith('/base')) {
          //this.router.navigate([navError.url.substr(5)]);
          return;
        }
        //this.router.navigate(['/base']);
      }
      if (val instanceof ActivationEnd) {
        this.initializeLanguage((val as ActivationEnd).snapshot.paramMap.get('language') || 'nl');
      } else if (val instanceof NavigationEnd) {
        this.activePath = this.location.path();
      }
    });
  }

  private initializeLanguage(language: string, redirect?: boolean): void {

    language = language || this.translateService.getBrowserLang() || '';

    if (!this.isSupportedLanguage(language)) {
      language = this.translateService.defaultLang;
    }
    if (this.translateService.currentLang !== language) {
      this.translateService.use(language);
      if (redirect) {
        this.router.navigate([language]);
      }
    }
  }

  private isSupportedLanguage(language: string): boolean {
    return this.translateService.getLangs().some(l => l === language);
  }
}
